// import React, { useState, useEffect, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../App.css";
// import "./Home.css";
// import procubed from "../asset/procubed1.png";
// import Company from "./Company";
// import PersonLogs from "./PersonLogs";
// import LiveStatus from "./LiveStatus"; // LIVE STATUS - COMMENTED OUT
// import companyIcon from "../asset/company.svg";
// import chevronDownIcon from "../asset/chevron-down.svg";

// let _liveLoaded = false;
// let _liveCache = [];

// const Home = ({ username, role, onLogout }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [activePage, setActivePage] = useState("company");
//   const [employees, setEmployees] = useState([]);
//   const [liveEmployees, setLiveEmployees] = useState([]); // LIVE STATUS - COMMENTED OUT
//   const [companies, setCompanies] = useState([]);
//   const [companyEmployeeCounts, setCompanyEmployeeCounts] = useState({});
//   const [showCompanyMenu, setShowCompanyMenu] = useState(() => {
//     const saved = sessionStorage.getItem('showCompanyMenu');
//     return saved ? JSON.parse(saved) : true;
//   });
//   const [selectedCompany, setSelectedCompany] = useState(null);
//   const [weeklyPresentData, setWeeklyPresentData] = useState([]);
//   const [usersCount, setUsersCount] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [liveLoading, setLiveLoading] = useState(false); // LIVE STATUS - COMMENTED OUT
//   const [liveError, setLiveError] = useState(null); // LIVE STATUS - COMMENTED OUT
//   const [personId, setPersonId] = useState(null);
//   const [usersData, setUsersData] = useState([]);
//   const [loadingCompanies, setLoadingCompanies] = useState(false);

//   const isFetchingLive = useRef(false);   
//   const liveDataLoaded = useRef(false);
//   const API = `https://${window.location.hostname}`;
//   const SPRING_API = `https://${window.location.hostname}/spring-api`;

//   const tabId = sessionStorage.getItem("activeTab");
//   const token = tabId ? sessionStorage.getItem(`token_${tabId}`) : null;

//   const headers = {
//     "Content-Type": "application/json",
//     Authorization: token ? `Bearer ${token}` : "",
//   };

//   const cache = React.useRef(new Map());
//   const CACHE_DURATION = 5 * 60 * 1000;

//   const cachedFetch = async (url, options = {}) => {
//     const cacheKey = url;
//     const now = Date.now();
//     const cached = cache.current.get(cacheKey);
//     if (cached && (now - cached.timestamp) < CACHE_DURATION) {
//       return cached.data;
//     }
//     const response = await fetch(url, { ...options, headers: { ...headers, ...options.headers } });
//     const data = await response.json();
//     cache.current.set(cacheKey, { data, timestamp: now });
//     return data;
//   };

//   const user = {
//     role: role,
//     username: username,
//     company_name: tabId ? sessionStorage.getItem(`company_${tabId}`) : null,
//     address: tabId ? sessionStorage.getItem(`address_${tabId}`) : null,
//   };

//   const convertFaceJpgToBase64 = (faceJpg) => {
//     if (!faceJpg || typeof faceJpg !== 'object') return "";
//     const data = faceJpg.data;
//     if (!Array.isArray(data)) return "";
//     try {
//       const bytes = data.map(num => num);
//       const binary = String.fromCharCode(...bytes);
//       return `data:image/jpeg;base64,${btoa(binary)}`;
//     } catch (e) {
//       return "";
//     }
//   };
//   const fetchCompanies = async () => {
//     try {
//       const data = await cachedFetch(`${SPRING_API}/users/companies/${username}/${role}`);
//       setCompanies(Array.isArray(data) ? data : []);
//     } catch (e) {
//       console.error("COMPANY ERROR", e);
//       setCompanies([]);
//     }
//   };

//   // LIVE STATUS - COMMENTED OUT
//   const fetchLive = async (forceRefresh = false) => {

//     if (_liveLoaded && !forceRefresh) {
//       console.log("⏭️ Live data already loaded, using cache");
//       setLiveEmployees(_liveCache); // restore from cache instantly, no spinner
//       return;
//     }
//     if (isFetchingLive.current) {
//       console.log("⏭️ fetchLive already in progress, skipping");
//       return;
//     }
//     isFetchingLive.current = true;
//     setLiveLoading(true);
//     setLiveError(null);
//     try {
//       const res = await fetch(`${SPRING_API}/employees/live/${username}/${role}`, { headers });
//       let data = await res.json();
//       if (!Array.isArray(data)) data = [];
//       data = data.map((emp) => ({
//         ...emp,
//         status: "Present",
//         imageUrl: emp.imageUrl
//           ? emp.imageUrl
//           : emp.faceJpg
//             ? convertFaceJpgToBase64(emp.faceJpg)
//             : "",
//       }));
//       setLiveEmployees(data);
//       _liveCache = data;       // save to module cache
//       _liveLoaded = true;      // mark loaded at module level
//       liveDataLoaded.current = true;
//     } catch (e) {
//       console.error("LIVE ERR", e);
//       setLiveError("Failed to fetch live status. Please try again.");
//     } finally {
//       setLiveLoading(false);
//       isFetchingLive.current = false;
//     }
//   };

//   // const fetchUsers = async () => {
//   //   try {
//   //     const data = await cachedFetch(`${API}/api/users`);
//   //     setUsersData(data);
//   //     setUsersCount(data.length);
//   //   } catch (e) {
//   //     console.error("USERS ERR", e);
//   //   }
//   // };

//   // LIVE STATUS - COMMENTED OUT
//   const refreshLive = async () => {
//     await fetchLive();
//   };

//   useEffect(() => {
//     if (location.pathname === '/live-status' || location.pathname === '/') {
//       setActivePage('live-status');
//       setPersonId(null);
//       setShowCompanyMenu(false);
//     } else if (location.pathname === '/company') {
//       setActivePage('company');
//       setPersonId(null);
//       setShowCompanyMenu(true);
//     } else if (location.pathname.startsWith('/person-logs/')) {
//       setActivePage('person-logs');
//       const id = location.pathname.split('/person-logs/')[1];
//       setPersonId(id);
//     }
//   }, [location.pathname]);

//   // FIX 2: Fetch correct employee counts per company
//   // const fetchAllCompanyEmployeeCounts = async () => {
//   //   if (!companies || companies.length === 0) return;
//   //   const countsMap = {};
//   //   for (const company of companies) {
//   //     try {
//   //       const response = await fetch(`${API}/api/employees/company/${encodeURIComponent(company)}`, {
//   //         headers: { Authorization: `Bearer ${token}` }
//   //       });
//   //       if (response.ok) {
//   //         const data = await response.json();
//   //         countsMap[company] = Array.isArray(data) ? data.length : 0;
//   //       }
//   //     } catch (error) {
//   //       console.error(`Error fetching employees for company '${company}':`, error);
//   //       countsMap[company] = 0;
//   //     }
//   //   }
//   //   setCompanyEmployeeCounts(countsMap);
//   // };


//   useEffect(() => {
//     if (!token) {
//       setLoading(false);
//       return;
//     }
//     (async () => {
//       await fetchCompanies();
//       setLoading(false);
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (companies.length > 0 && !selectedCompany) {
//       const userCompany = user.company_name;
//       if (userCompany && companies.includes(userCompany)) {
//         setSelectedCompany(userCompany);
//       } else {
//         setSelectedCompany(companies[0]);
//       }
//     }
//   }, [companies, selectedCompany, user.company_name]);

//   useEffect(() => {
//     if (weeklyPresentData.length > 0) {
//       const today = new Date();
//       const dayIndex = today.getDay();
//       const adjustedIndex = dayIndex === 0 ? 6 : dayIndex - 1;
//       const todayCount = liveEmployees.length;
//       const updatedData = [...weeklyPresentData];
//       if (updatedData[adjustedIndex] !== undefined) {
//         updatedData[adjustedIndex] = { ...updatedData[adjustedIndex], count: todayCount };
//       }
//       setWeeklyPresentData(updatedData);
//     }
//   }, [liveEmployees, weeklyPresentData.length]);

//   // useEffect(() => {
//   //   if (companies && companies.length > 0 && token) {
//   //     fetchAllCompanyEmployeeCounts();
//   //   }
//   // }, [companies, token]);

//   // LIVE STATUS - COMMENTED OUT
//   useEffect(() => {
//     if (activePage === "live-status" && token) {
//       fetchLive();
//     }
//   }, [activePage, token]);

//   const totalEmployees = employees.length;
//   const presentToday = liveEmployees.length;
  
//   // const allDayLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//   // const todayDayIndex = (() => {
//   //   const d = new Date().getDay(); // 0=Sun
//   //   return d === 0 ? 6 : d - 1;   // Mon=0 ... Sun=6
//   // })();
//   // // Rotate: days after today come first, today comes last
//   // const weekLabels = [
//   //   ...allDayLabels.slice(todayDayIndex + 1),
//   //   ...allDayLabels.slice(0, todayDayIndex + 1),
//   // ];
//   // const allCounts = weeklyPresentData.length === 7
//   //   ? weeklyPresentData.map(d => d.count)
//   //   : Array(7).fill(0);
//   // const rotatedCounts = [
//   //   ...allCounts.slice(todayDayIndex + 1),
//   //   ...allCounts.slice(0, todayDayIndex + 1),
//   // ];


//   return (
//     <div className="home-container">

//       {/* HEADER */}
//       <header className="home-header">
//         <div className="header-left">
//           <img src={procubed} alt="Logo" />
//           <span>PROcubed</span>
//         </div>
//         <div className="header-right">
//           <div className="user-circle">{username?.charAt(0).toUpperCase()}</div>
//           <span>{username}</span>
//           <button className="logout-btn" onClick={onLogout}>Logout</button>
//         </div>
//       </header>

//       <div className="home-content">

//         {/* SIDEBAR */}
//         <aside className="sidebar">
//           <div className="menu-item">
//             <button
//               className={`menu-btn ${activePage === "live-status" ? "active" : ""}`}
//               onClick={() => {
//                 navigate("/live-status");
//                 setActivePage("live-status");
//                 setShowCompanyMenu(false);
//               }}
//             >
//               <i className="fas fa-signal me-2"></i> Live Status
//             </button>
//           </div>
         

//           <div className="menu-item">
//             <button
//               className={`menu-btn ${activePage.startsWith("company") ? "active" : ""}`}
//               onClick={() => {
//                 setShowCompanyMenu(!showCompanyMenu);
//                 if (!showCompanyMenu) {
//                   navigate("/company");
//                   setSelectedCompany(null);
//                 }
//               }}
//             >
//               <img src={companyIcon} alt="company" className="me-2" style={{ width: '16px', height: '16px' }} /> Company
//               <span
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   setShowCompanyMenu(!showCompanyMenu);
//                 }}
//                 style={{ cursor: 'pointer', marginLeft: 'auto' }}
//               >
//                 <img
//                   src={chevronDownIcon}
//                   alt="chevron"
//                   style={{
//                     width: '16px', height: '16px',
//                     transform: showCompanyMenu ? 'rotate(180deg)' : 'rotate(0deg)',
//                     transition: 'transform 0.2s ease'
//                   }}
//                 />
//               </span>
//             </button>

//             {/* ✅ FIX 3: Submenu alignment fixed */}
//             {showCompanyMenu && (
//               <div className="submenu" style={{
//                 paddingLeft: '0',
//                 marginTop: '2px',
//                 borderLeft: '2px solid #e0e0e0',
//                 marginLeft: '12px',
//               }}>
//                 {loadingCompanies ? (
//                   <div className="text-center py-2">
//                     <div className="spinner-border spinner-border-sm text-success" role="status"></div>
//                     <small className="text-muted ms-2">Loading...</small>
//                   </div>
//                 ) : companies.length === 0 ? (
//                   <div className="text-center py-2">
//                     <small className="text-muted">No companies found</small>
//                   </div>
//                 ) : (
//                   companies.map((company) => {
//                     const employeeCount = companyEmployeeCounts[company] || 0;
//                     const hasEmployees = employeeCount > 0;
//                     return (
//                       <button
//                         key={company}
//                         className={`submenu-btn ${selectedCompany === company ? "active" : ""}`}
//                         onClick={() => {
//                           navigate("/company");
//                           setSelectedCompany(company);
//                         }}
//                         style={{
//                           display: 'flex',
//                           justifyContent: 'space-between',
//                           alignItems: 'center',
//                           width: '100%',
//                           padding: '6px 10px',
//                           textAlign: 'left',
//                         }}
//                         title={hasEmployees ? `${employeeCount} employee${employeeCount !== 1 ? 's' : ''}` : "No employees"}
//                       >
//                         <span style={{ color: '#000', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                           {company}
//                         </span>
//                         {hasEmployees ? (
//                           <span style={{ fontSize: '0.8em', color: '#28a745', fontWeight: 'bold', flexShrink: 0, marginLeft: '4px' }}>
//                             ({employeeCount})
//                           </span>
//                         ) : (
//                           <span style={{ fontSize: '0.8em', color: '#dc3545', fontWeight: 'bold', flexShrink: 0, marginLeft: '4px' }}>
//                             ●
//                           </span>
//                         )}
//                       </button>
//                     );
//                   })
//                 )}
//               </div>
//             )}
//           </div>
//         </aside>

//         {/* MAIN CONTENT */}
//         <main className="main-area">
//           {activePage === "live-status" && (
//             <LiveStatus
//               username={username}
//               onLogout={onLogout}
//               employees={liveEmployees}
//               loading={liveLoading}
//               error={liveError}
//               onRefresh={fetchLive}
//               companies={companies}
//               setSelectedCompany={setSelectedCompany}
//             />
//           )}
         

//           {activePage === "company" && (
//             <Company
//               companies={companies}
//               employees={employees}
//               selectedCompany={selectedCompany}
//               navigate={navigate}
//               onBack={() => navigate("/")}
//             />
//           )}

//           {activePage === "person-logs" && personId && (
//             <PersonLogs
//               username={username}
//               onLogout={onLogout}
//               personId={personId}
//               onBack={() => navigate(-1)}
//             />
//           )}
//         </main>

//       </div>
//     </div>
//   );
// };

// export default Home;



import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import "./Home.css";
import procubed from "../asset/procubed1.png";
import Company from "./Company";
import PersonLogs from "./PersonLogs";
import LiveStatus from "./LiveStatus"; // LIVE STATUS - COMMENTED OUT
import companyIcon from "../asset/company.svg";
import chevronDownIcon from "../asset/chevron-down.svg";

let _liveLoaded = false;
let _liveCache = [];

const Home = ({ username, role, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("company");
  const [employees, setEmployees] = useState([]);
  const [liveEmployees, setLiveEmployees] = useState([]); // LIVE STATUS - COMMENTED OUT
  const [companies, setCompanies] = useState([]);
  const [companyEmployeeCounts, setCompanyEmployeeCounts] = useState({});
  const [showCompanyMenu, setShowCompanyMenu] = useState(() => {
    const saved = sessionStorage.getItem('showCompanyMenu');
    return saved ? JSON.parse(saved) : true;
  });
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [weeklyPresentData, setWeeklyPresentData] = useState([]);
  const [usersCount, setUsersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [liveLoading, setLiveLoading] = useState(false); // LIVE STATUS - COMMENTED OUT
  const [liveError, setLiveError] = useState(null); // LIVE STATUS - COMMENTED OUT
  const [personId, setPersonId] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(false);

  const isFetchingLive = useRef(false);   
  const liveDataLoaded = useRef(false);
  const API = `https://${window.location.hostname}`;
  const SPRING_API = `https://${window.location.hostname}/spring-api`;

  const tabId = sessionStorage.getItem("activeTab");
  const token = tabId ? sessionStorage.getItem(`token_${tabId}`) : null;

  const headers = {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  };

  const cache = React.useRef(new Map());
  const CACHE_DURATION = 5 * 60 * 1000;

  const cachedFetch = async (url, options = {}) => {
    const cacheKey = url;
    const now = Date.now();
    const cached = cache.current.get(cacheKey);
    if (cached && (now - cached.timestamp) < CACHE_DURATION) {
      return cached.data;
    }
    const response = await fetch(url, { ...options, headers: { ...headers, ...options.headers } });
    const data = await response.json();
    cache.current.set(cacheKey, { data, timestamp: now });
    return data;
  };

  const user = {
    role: role,
    username: username,
    company_name: tabId ? sessionStorage.getItem(`company_${tabId}`) : null,
    address: tabId ? sessionStorage.getItem(`address_${tabId}`) : null,
  };

  const convertFaceJpgToBase64 = (faceJpg) => {
    if (!faceJpg || typeof faceJpg !== 'object') return "";
    const data = faceJpg.data;
    if (!Array.isArray(data)) return "";
    try {
      const bytes = data.map(num => num);
      const binary = String.fromCharCode(...bytes);
      return `data:image/jpeg;base64,${btoa(binary)}`;
    } catch (e) {
      return "";
    }
  };
  const fetchCompanies = async () => {
    try {
      const data = await cachedFetch(`${SPRING_API}/users/companies/${username}/${role}`);
      setCompanies(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("COMPANY ERROR", e);
      setCompanies([]);
    }
  };

  // LIVE STATUS - COMMENTED OUT
  const fetchLive = async (forceRefresh = false) => {

    if (_liveLoaded && !forceRefresh) {
      console.log("⏭️ Live data already loaded, using cache");
      setLiveEmployees(_liveCache); // restore from cache instantly, no spinner
      return;
    }
    if (isFetchingLive.current) {
      console.log("⏭️ fetchLive already in progress, skipping");
      return;
    }
    isFetchingLive.current = true;
    setLiveLoading(true);
    setLiveError(null);
    try {
      const res = await fetch(`${SPRING_API}/employees/live/${username}/${role}`, { headers });
      let data = await res.json();
      if (!Array.isArray(data)) data = [];
      // No image mapping needed — live status is text-only
      setLiveEmployees(data);
      _liveCache = data;       // save to module cache
      _liveLoaded = true;      // mark loaded at module level
      liveDataLoaded.current = true;
    } catch (e) {
      console.error("LIVE ERR", e);
      setLiveError("Failed to fetch live status. Please try again.");
    } finally {
      setLiveLoading(false);
      isFetchingLive.current = false;
    }
  };

  // const fetchUsers = async () => {
  //   try {
  //     const data = await cachedFetch(`${API}/api/users`);
  //     setUsersData(data);
  //     setUsersCount(data.length);
  //   } catch (e) {
  //     console.error("USERS ERR", e);
  //   }
  // };

  // LIVE STATUS - COMMENTED OUT
  const refreshLive = async () => {
    await fetchLive();
  };

  useEffect(() => {
    if (location.pathname === '/live-status' || location.pathname === '/') {
      setActivePage('live-status');
      setPersonId(null);
      setShowCompanyMenu(false);
    } else if (location.pathname === '/company') {
      setActivePage('company');
      setPersonId(null);
      setShowCompanyMenu(true);
    } else if (location.pathname.startsWith('/person-logs/')) {
      setActivePage('person-logs');
      const id = location.pathname.split('/person-logs/')[1];
      setPersonId(id);
    }
  }, [location.pathname]);

  // FIX 2: Fetch correct employee counts per company
  // const fetchAllCompanyEmployeeCounts = async () => {
  //   if (!companies || companies.length === 0) return;
  //   const countsMap = {};
  //   for (const company of companies) {
  //     try {
  //       const response = await fetch(`${API}/api/employees/company/${encodeURIComponent(company)}`, {
  //         headers: { Authorization: `Bearer ${token}` }
  //       });
  //       if (response.ok) {
  //         const data = await response.json();
  //         countsMap[company] = Array.isArray(data) ? data.length : 0;
  //       }
  //     } catch (error) {
  //       console.error(`Error fetching employees for company '${company}':`, error);
  //       countsMap[company] = 0;
  //     }
  //   }
  //   setCompanyEmployeeCounts(countsMap);
  // };


  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    (async () => {
      await fetchCompanies();
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (companies.length > 0 && !selectedCompany) {
      const userCompany = user.company_name;
      if (userCompany && companies.includes(userCompany)) {
        setSelectedCompany(userCompany);
      } else {
        setSelectedCompany(companies[0]);
      }
    }
  }, [companies, selectedCompany, user.company_name]);

  useEffect(() => {
    if (weeklyPresentData.length > 0) {
      const today = new Date();
      const dayIndex = today.getDay();
      const adjustedIndex = dayIndex === 0 ? 6 : dayIndex - 1;
      const todayCount = liveEmployees.length;
      const updatedData = [...weeklyPresentData];
      if (updatedData[adjustedIndex] !== undefined) {
        updatedData[adjustedIndex] = { ...updatedData[adjustedIndex], count: todayCount };
      }
      setWeeklyPresentData(updatedData);
    }
  }, [liveEmployees, weeklyPresentData.length]);

  // useEffect(() => {
  //   if (companies && companies.length > 0 && token) {
  //     fetchAllCompanyEmployeeCounts();
  //   }
  // }, [companies, token]);

  // LIVE STATUS - COMMENTED OUT
  useEffect(() => {
    if (activePage === "live-status" && token) {
      fetchLive();
    }
  }, [activePage, token]);

  const totalEmployees = employees.length;
  const presentToday = liveEmployees.length;
  
  // const allDayLabels = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  // const todayDayIndex = (() => {
  //   const d = new Date().getDay(); // 0=Sun
  //   return d === 0 ? 6 : d - 1;   // Mon=0 ... Sun=6
  // })();
  // // Rotate: days after today come first, today comes last
  // const weekLabels = [
  //   ...allDayLabels.slice(todayDayIndex + 1),
  //   ...allDayLabels.slice(0, todayDayIndex + 1),
  // ];
  // const allCounts = weeklyPresentData.length === 7
  //   ? weeklyPresentData.map(d => d.count)
  //   : Array(7).fill(0);
  // const rotatedCounts = [
  //   ...allCounts.slice(todayDayIndex + 1),
  //   ...allCounts.slice(0, todayDayIndex + 1),
  // ];


  return (
    <div className="home-container">

      {/* HEADER */}
      <header className="home-header">
        <div className="header-left">
          <img src={procubed} alt="Logo" />
          <span>PROcubed</span>
        </div>
        <div className="header-right">
          <div className="user-circle">{username?.charAt(0).toUpperCase()}</div>
          <span>{username}</span>
          <button className="logout-btn" onClick={onLogout}>Logout</button>
        </div>
      </header>

      <div className="home-content">

        {/* SIDEBAR */}
        <aside className="sidebar">
          <div className="menu-item">
            <button
              className={`menu-btn ${activePage === "live-status" ? "active" : ""}`}
              onClick={() => {
                navigate("/live-status");
                setActivePage("live-status");
                setShowCompanyMenu(false);
              }}
            >
              <i className="fas fa-signal me-2"></i> Live Status
            </button>
          </div>
         

          <div className="menu-item">
            <button
              className={`menu-btn ${activePage.startsWith("company") ? "active" : ""}`}
              onClick={() => {
                setShowCompanyMenu(!showCompanyMenu);
                if (!showCompanyMenu) {
                  navigate("/company");
                  setSelectedCompany(null);
                }
              }}
            >
              <img src={companyIcon} alt="company" className="me-2" style={{ width: '16px', height: '16px' }} /> Company
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setShowCompanyMenu(!showCompanyMenu);
                }}
                style={{ cursor: 'pointer', marginLeft: 'auto' }}
              >
                <img
                  src={chevronDownIcon}
                  alt="chevron"
                  style={{
                    width: '16px', height: '16px',
                    transform: showCompanyMenu ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }}
                />
              </span>
            </button>

            {/* ✅ FIX 3: Submenu alignment fixed */}
            {showCompanyMenu && (
              <div className="submenu" style={{
                paddingLeft: '0',
                marginTop: '2px',
                borderLeft: '2px solid #e0e0e0',
                marginLeft: '12px',
              }}>
                {loadingCompanies ? (
                  <div className="text-center py-2">
                    <div className="spinner-border spinner-border-sm text-success" role="status"></div>
                    <small className="text-muted ms-2">Loading...</small>
                  </div>
                ) : companies.length === 0 ? (
                  <div className="text-center py-2">
                    <small className="text-muted">No companies found</small>
                  </div>
                ) : (
                  companies.map((company) => {
                    const employeeCount = companyEmployeeCounts[company] || 0;
                    const hasEmployees = employeeCount > 0;
                    return (
                      <button
                        key={company}
                        className={`submenu-btn ${selectedCompany === company ? "active" : ""}`}
                        onClick={() => {
                          navigate("/company");
                          setSelectedCompany(company);
                        }}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%',
                          padding: '6px 10px',
                          textAlign: 'left',
                        }}
                        title={hasEmployees ? `${employeeCount} employee${employeeCount !== 1 ? 's' : ''}` : "No employees"}
                      >
                        <span style={{ color: '#000', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {company}
                        </span>
                        {hasEmployees ? (
                          <span style={{ fontSize: '0.8em', color: '#28a745', fontWeight: 'bold', flexShrink: 0, marginLeft: '4px' }}>
                            ({employeeCount})
                          </span>
                        ) : (
                          <span style={{ fontSize: '0.8em', color: '#dc3545', fontWeight: 'bold', flexShrink: 0, marginLeft: '4px' }}>
                            ●
                          </span>
                        )}
                      </button>
                    );
                  })
                )}
              </div>
            )}
          </div>
        </aside>

        {/* MAIN CONTENT */}
        <main className="main-area">
          {activePage === "live-status" && (
            <LiveStatus
              username={username}
              onLogout={onLogout}
              employees={liveEmployees}
              loading={liveLoading}
              error={liveError}
              onRefresh={fetchLive}
              companies={companies}
              setSelectedCompany={setSelectedCompany}
            />
          )}
         

          {activePage === "company" && (
            <Company
              companies={companies}
              employees={employees}
              selectedCompany={selectedCompany}
              navigate={navigate}
              onBack={() => navigate("/")}
            />
          )}

          {activePage === "person-logs" && personId && (
            <PersonLogs
              username={username}
              onLogout={onLogout}
              personId={personId}
              onBack={() => navigate(-1)}
            />
          )}
        </main>

      </div>
    </div>
  );
};

export default Home;